export const URL_SERVER = process.env.REACT_APP_URL_APISELECT//"http://localhost:5000"
export const DATA_APP_CONTEXT = 'DATA_APP_CONTEXT'
export const DATA_APP_REGISTER_CONTEXT = 'DATA_APP_REGISTER_CONTEXT'



